/**
 * Phase 125.34 — Promo-Carousel: zeigt Rodeo- und Eisenbahn-Slider abwechselnd.
 *
 * - Auto-Advance alle 7 Sekunden
 * - Dots zur manuellen Auswahl
 * - Pause on hover
 * - Nutzt die bestehenden Slider-Komponenten unverändert (jede bringt ihre
 *   eigenen Wellen top/bottom mit)
 */
import React, { useEffect, useRef, useState } from 'react';
import HomeRodeoBanner from './HomeRodeoBanner';
import HomeTrainBanner from './HomeTrainBanner';

const AUTO_ADVANCE_MS = 7000;

const HomePromoCarousel = ({ rodeoConfig, trainConfig, topBg, bottomBg }) => {
  const slides = [];
  if (rodeoConfig?.enabled !== false) {
    slides.push({ key: 'rodeo', render: (t, b) => <HomeRodeoBanner config={rodeoConfig} topBg={t} bottomBg={b} /> });
  }
  if (trainConfig?.enabled !== false) {
    slides.push({ key: 'train', render: (t, b) => <HomeTrainBanner config={trainConfig} topBg={t} bottomBg={b} /> });
  }
  const [idx, setIdx] = useState(0);
  const paused = useRef(false);

  useEffect(() => {
    if (slides.length <= 1) return undefined;
    const t = setInterval(() => {
      if (!paused.current) setIdx((i) => (i + 1) % slides.length);
    }, AUTO_ADVANCE_MS);
    return () => clearInterval(t);
  }, [slides.length]);

  if (slides.length === 0) return null;
  if (slides.length === 1) return slides[0].render(topBg, bottomBg);

  return (
    <div
      className="relative"
      data-testid="home-promo-carousel"
      onMouseEnter={() => { paused.current = true; }}
      onMouseLeave={() => { paused.current = false; }}
      style={{ backgroundColor: bottomBg || '#ffffff' }}
    >
      <div className="grid" style={{ gridTemplateAreas: "'slide'" }}>
        {slides.map((s, i) => (
          <div
            key={s.key}
            className="transition-opacity duration-700 ease-in-out"
            style={{
              gridArea: 'slide',
              opacity: i === idx ? 1 : 0,
              pointerEvents: i === idx ? 'auto' : 'none',
            }}
            aria-hidden={i !== idx}
          >
            {s.render(topBg, bottomBg)}
          </div>
        ))}
      </div>
    </div>
  );
};

export default HomePromoCarousel;
